<template>
  <div class="app">
    <router-view />
  </div>
</template>

<script setup>
import './el.css.js'
</script>

<style lang="less">
// 将el-table改造成excel风格的表格（1.紧凑表格；2.文本输入居左；3.数字输入居右侧；4.不显示el输入框边框）
.exceltable {

  .el-table__body {
    .el-table__cell {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .el-table__footer {
    .el-table__cell {
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }

  .el-table__cell {
    .cell {
      padding-left: 2px;
      padding-right: 2px;
      text-shadow: 1px;

      .el-input__wrapper {
        border-radius: 0;
        padding-left: 0;
        padding-right: 0;
        box-shadow: 0 0 0 0;
        background-color: transparent;
      }

      .el-select__wrapper {
        border-radius: 0;
        padding-left: 0;
        padding-right: 0;
        box-shadow: 0 0 0 0;
        background-color: transparent;
      }

      .el-input-number {
        width: 100%;

        .el-input__inner {
          text-align: right;
        }
      }
    }
  }
}
</style>